module.exports = __webpack_public_path__ + "static/media/2 (47).64281dfc.jpg";